import { render } from "./DateBox.vue?vue&type=template&id=615565f4&scoped=true"
import script from "./DateBox.vue?vue&type=script&lang=js"
export * from "./DateBox.vue?vue&type=script&lang=js"

import "./DateBox.vue?vue&type=style&index=0&id=615565f4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-615565f4"

export default script